module.exports = __webpack_public_path__ + "static/img/trial.469973e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trial.gif
// module id = eiUe
// module chunks = 1